import { forwardRef } from 'react';
import { GyldendalLogoSmall } from '@ui/kit';
import { throbberCls } from './styles/Throbber.js';
import { jsx } from 'react/jsx-runtime';

const Throbber = /*#__PURE__*/forwardRef(function Throbber({
  height = 60
}, ref) {
  return /*#__PURE__*/jsx("i", {
    ref: ref,
    className: throbberCls,
    children: /*#__PURE__*/jsx(GyldendalLogoSmall, {
      height: height,
      disableDefaultClassName: true
    })
  });
});

export { Throbber };
//# sourceMappingURL=Throbber.js.map
